
import {  useMemo } from 'react' ; 
  interface PaginationData {
    totalCount: number , 
    pageSize : number , 
    sibilingCount:number , 
    currentPage : number , 
} 


export const Dots = '--' ; 

export const range=(start : any , end : any )=>{
    const length = end - start + 1;
    return Array.from({ length }, (_, idx) => idx + start);
}

 const usePagination  =({totalCount , pageSize ,  sibilingCount ,currentPage  } : PaginationData)=>{

    const paginationRange  =useMemo(()=>{
        // calculate the number of pageds we have under the table  
        const totalPageCount=Math.ceil( totalCount / pageSize ) ; 
        //// Pages count is determined as siblingCount + firstPage + lastPage + currentPage + 2*DOTS
        const totalPageNumbers= sibilingCount + 5  ; 

        if(totalPageNumbers >= totalPageCount){
            return range(1 , totalPageCount)
        }

        const leftSideSibilingIndex =Math.max(currentPage - sibilingCount , 1) ; 
        const rightSideSibilingIndex=Math.min(currentPage + sibilingCount , totalPageCount )


        const shouldShowhowLeftDots = leftSideSibilingIndex > 2 ; 
        const shouldShowRightDots = rightSideSibilingIndex < totalPageCount -2 ; 
        
        const firstPageIndex = 1 ; 
        const lastPageIndex = totalPageCount ; 
        /*
    	Case 2: No left dots to show, but rights dots to be show */
        if(!shouldShowhowLeftDots && shouldShowRightDots){
            const leftItemCount = (3+2) * sibilingCount ; 
            const leftRange=range( 1 , leftItemCount)
            return [...leftRange ,Dots , totalPageCount ]
        }

        /*Case 3: No right dots to show, but left dots to be shown */ 

        if( shouldShowhowLeftDots && !shouldShowRightDots ){
            const rightItemCount = (3+2)*sibilingCount  ; 
            const rightRange =range(totalPageCount - rightItemCount +1  , totalPageCount)  ; 
            return [firstPageIndex , Dots , ...rightRange ]
        }
        
        /*
    	Case 4: Both left and right dots to be shown */ 

        if(shouldShowhowLeftDots && shouldShowRightDots){
            const middleRange=range(leftSideSibilingIndex , rightSideSibilingIndex) ; 
            return[firstPageIndex, Dots , ...middleRange , Dots , lastPageIndex]
        }
        
    },[currentPage, totalCount , pageSize])
    //[totalCount , pageSize , sibilingCount , currentPage]
    
    return [paginationRange] ; 
}

export default  usePagination ; 

